// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StartPage__root--MlIS {
    width: 100%;
    min-height: calc(100vh - 216px);
}

.StartPage__main--olch {
    background-color: var(--main-color);
    padding: 0 16px 32px 16px;
}

@media screen and (min-width: 1024px) {

.StartPage__main--olch {
        padding: 0 60px 60px 60px
}
    }

@media screen and (min-width: 1024px) and (max-width: 1381px) {

.StartPage__main--olch {
        padding: 0 16px 32px 16px
}
    }

.StartPage__secondaryContent--YOuY {
    background-color: var(--obscure-color);
    padding: 32px 16px;
}

@media screen and (min-width: 1024px) {

.StartPage__secondaryContent--YOuY {
        padding: 60px
}
    }

@media screen and (min-width: 1024px) and (max-width: 1381px) {

.StartPage__secondaryContent--YOuY {
        padding: 60px 16px
}
    }

.StartPage__wrapper--ivVu {
    max-width: var(--content-max-width);
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.StartPage__section--b45V {
    border: 4px solid var(--obscure-color);
    background-color: var(--main-light-color);
    border-radius: 12px;
}

.StartPage__sectionStatictics--a6xm {
    border: 4px solid var(--tertiary-color);
    background-color: var(--main-light-color);
    border-radius: 12px;
    padding: 16px;
    color: var(--darkest-color);
    display: flex;
    flex-direction: column;
    gap: 36px;
}

@media screen and (min-width: 1024px) {

.StartPage__sectionStatictics--a6xm {
        padding: 32px;
        margin-bottom: 28px
}
    }

.StartPage__sectionStatictics--a6xm .StartPage__description--oyRA {
        margin-bottom: 0;
    }

.StartPage__sectionWithBg--KcvV {
    padding: 32px 16px;
    background-position: 65%;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: var(--main-bg);
    color: var(--darkest-color);
    position: relative;
    overflow: hidden;
}

.StartPage__sectionWithBg--KcvV::after {
        content: '';
        display: block;
        width: 250%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(269.99deg, rgba(216, 217, 239, 0) 50.53%, rgba(249, 249, 253, 0.853946) 79.62%, #FFFFFF 99.99%);
    }

@media screen and (min-width: 1024px) {

.StartPage__sectionWithBg--KcvV {
        padding: 92px 32px;
        background-image: var(--main-bg);
        background-position: center
}

        .StartPage__sectionWithBg--KcvV::after {
            display: none;
        }
    }

.StartPage__sectionWithBgWrapper--wqem {
    max-width: 468px;
    position: relative;
    z-index: 1;
}

.StartPage__sectionAbout--iAtI {
    color: var(--tertiary-color);
}

.StartPage__sectionAbout--iAtI .StartPage__secondaryTitle--lH_5,
    .StartPage__sectionAbout--iAtI .StartPage__description--oyRA {
        max-width: 468px;
    }

.StartPage__sectionAbout--iAtI .StartPage__description--oyRA {
        margin-bottom: 24px;
    }

.StartPage__sectionReady--BcDI {
    padding: 16px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    color: var(--tertiary-color);
    border-radius: 12px;
}

@media screen and (min-width: 1024px) {

.StartPage__sectionReady--BcDI {
        padding: 28px 32px 32px
}
    }

.StartPage__sectionReady--BcDI .StartPage__description--oyRA {
        margin-bottom: 0;
    }

.StartPage__title--LlZu {
    font-size: 32px;
    line-height: 42px;
    font-weight: 400;
    margin-bottom: 16px;
}

.StartPage__secondaryTitle--lH_5 {
    font-weight: 700;
    font-size: 26px;
    line-height: 34px;
    margin-bottom: 16px;
}

.StartPage__tertiaryTitle--d5Q1 {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 16px;
}

.StartPage__description--oyRA {
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    margin-bottom: 32px;
}

.StartPage__tag--wFXB {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: var(--main-color);
}

.StartPage__button--pTv_ {
    width: 100%;
    max-width: 260px;
    margin-bottom: 16px;
    font-size: 12px;
    font-weight: 700;
}

.StartPage__buttonStart--YSrC {
    font-size: 12px;
    font-weight: 700;
} 

.StartPage__buttonLearn--iQk6 {
    --icon-size: 16px;
    border-color: var(--gray-color);
    color: var(--main-light-color);
    font-size: 12px;
    font-weight: 700;
}

.StartPage__buttons--Vcl8 {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

@media screen and (min-width: 1024px) {

.StartPage__buttons--Vcl8 {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: start;
        grid-gap: 24px;
        padding-top: 24px
}
    }

.StartPage__smallNotice--oq0H {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--darkest-color);
    max-width: 260px;
}

.StartPage__advantageList--MPYi {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

@media screen and (min-width: 1024px) {

.StartPage__advantageList--MPYi {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 24px
}
    }

.StartPage__advantageItem--uq8L {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.StartPage__advantageItemImage--oZCX {
    width: 32px;
    height: 32px;
}

.StartPage__advantageItemTitle--yhA4 {
    color: var(--tertiary-color);
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
}

.StartPage__advantageItemDescription--pnhQ {
    color: var(--tertiary-color);
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;    
}

.StartPage__serviceList--Sh8c {
    display: flex;
    flex-wrap: wrap;
    -moz-column-gap: 12px;
         column-gap: 12px;
    row-gap: 24px;
}

.StartPage__serviceCard--A4JE {
    border: 4px solid var(--obscure-color);
    background-color: var(--main-light-color);
    border-radius: 12px;
    padding: 12px;
    position: relative;
}

@media screen and (max-width: 518px) {
        .StartPage__serviceCard--A4JE:nth-child(3) .StartPage__serviceCardImageBg--FXkM {
            background-position: -35px 22px;
        }
    }

@media screen and (max-width: 1023px) {

.StartPage__serviceCard--A4JE {
        overflow: hidden
}

        .StartPage__serviceCard--A4JE:nth-child(2) {
            overflow: visible;
        }
    
        .StartPage__serviceCard--A4JE:nth-child(2) .StartPage__serviceCardImageBg--FXkM {
            width: 122px;
            height: calc(100% + 15px);
            right: -15px;
            top: -15px;
            background-size: cover;
            background-position: top left;
        }
    
        .StartPage__serviceCard--A4JE:nth-child(1) .StartPage__serviceCardImageBg--FXkM,
        .StartPage__serviceCard--A4JE:nth-child(3) .StartPage__serviceCardImageBg--FXkM,
        .StartPage__serviceCard--A4JE:nth-child(4) .StartPage__serviceCardImageBg--FXkM,
        .StartPage__serviceCard--A4JE:nth-child(5) .StartPage__serviceCardImageBg--FXkM {
            width: 33.3%;
            max-width: 220px;
            height: 100%;
            background-size: cover;
            background-position: left center;
        }
    }

@media screen and (min-width: 1024px) {

.StartPage__serviceCard--A4JE {
        padding: 28px
}

        .StartPage__serviceCard--A4JE:nth-child(1) .StartPage__serviceCardImageBg--FXkM {
            width: 220px;
            height: 220px;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
        }

        .StartPage__serviceCard--A4JE:nth-child(2) .StartPage__serviceCardImageBg--FXkM {
            width: 134px;
            height: calc(100% + 15px);
            right: -15px;
            top: -11px;
        }

        .StartPage__serviceCard--A4JE:nth-child(3) .StartPage__serviceCardImageBg--FXkM {
            width: 112px;
            height: 100%;
            background-size: cover;
            background-position: -4px 0;
        }

        .StartPage__serviceCard--A4JE:nth-child(4) .StartPage__serviceCardImageBg--FXkM {
            width: 272px;
            height: 100%;
            background-position: top right;
        }

        .StartPage__serviceCard--A4JE:nth-child(5) .StartPage__serviceCardImageBg--FXkM {
            width: 382px;
            height: calc(100% + 32px);
            top: -28px;
            right: 0;
            background-size: cover;
        }
    }

.StartPage__serviceCardSmall--j_cw {
    width: 100%;
}

@media screen and (min-width: 1024px) {

.StartPage__serviceCardSmall--j_cw {
        width: 386px
}
    }

.StartPage__serviceCardMedium--dMGV {
    width: 100%;
}

@media screen and (min-width: 1024px) {

.StartPage__serviceCardMedium--dMGV {
        width: 562px
}
    }

.StartPage__serviceCardBig--lESw {
    width: 100%;
    padding: 12px;
}

@media screen and (min-width: 1024px) {

.StartPage__serviceCardBig--lESw {
        padding: 12px 28px 28px 28px
}

        .StartPage__serviceCardBig--lESw .StartPage__serviceCardContent--H8TB {
            max-width: 517px;
        }
    }

.StartPage__serviceCardContent--H8TB {
    max-width: 200px;
    color: var(--darkest-color);
    position: relative;
    z-index: 2;
}

@media screen and (min-width: 1024px) {

.StartPage__serviceCardContent--H8TB {
        max-width: 240px
}
    }

@media screen and (min-width: 768px) and (max-width: 1024px) {

.StartPage__serviceCardContent--H8TB {
        max-width: 300px
}
    }

.StartPage__serviceCardTitle--ohbZ {
    font-weight: 400;
    font-size: 22px;
    line-height: 28px;
    margin-bottom: 16px;
}

.StartPage__serviceCardDescription--DfZ9 {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
}

.StartPage__serviceCardImageBg--FXkM {
    position: absolute;
    top: 0;
    right: 0;
    background-image: var(--mobile-image-bg);
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

@media screen and (min-width: 1024px) {

.StartPage__serviceCardImageBg--FXkM {
        background-image: var(--image-bg)
}
    }

.StartPage__serviceCardTag--Is08 {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: var(--warning-color);
}

.StartPage__secondaryWrapper--Z0cE {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

@media screen and (min-width: 1024px) {

.StartPage__secondaryWrapper--Z0cE {
        display: grid;
        grid-template-columns: 436px auto;
        grid-gap: 24px
}
    }

.StartPage__mark--QIhK {
    font-weight: 600;
    font-style: italic;
    font-size: 14px;
    line-height: 18px;
}

@media screen and (min-width: 1024px) {

.StartPage__mark--QIhK {
        width: 320px;
        margin-left: auto
}
    }

.StartPage__statisticsList--cxRT {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

@media screen and (min-width: 1024px) {

.StartPage__statisticsList--cxRT {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 24px
}
    }

.StartPage__statisticCard--cE93 {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border-radius: 12px;
    background-color: var(--tertiary-color);
    color: var(--darkest-color);
}

@media screen and (min-width: 1024px) {

.StartPage__statisticCard--cE93 {
        padding: 32px
}
    }

.StartPage__statisticCardWrapper--FthL {
    display: grid;
    grid-template-columns: 32px auto;
    align-items: center;
    grid-gap: 16px;
}

.StartPage__statisticCardImage--Ncn7 {
    width: 32px;
    height: 32px;
}

.StartPage__statisticCardTitle--GHNi {
    font-weight: 400;
    font-size: 22px;
    line-height: 28px;
}

.StartPage__statisticCardDescription--gJDZ {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;    
}
`, "",{"version":3,"sources":["webpack://./src/ui/pages/StartPage/StartPage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;AAS7B;;AAPI;;AAJJ;QAKQ;AAMR;IALI;;AAEA;;AARJ;QASQ;AAER;IADI;;AAGJ;IACI,sCAAsC;IACtC,kBAAkB;AAStB;;AAPI;;AAJJ;QAKQ;AAMR;IALI;;AAEA;;AARJ;QASQ;AAER;IADI;;AAGJ;IACI,mCAAmC;IACnC,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,sCAAsC;IACtC,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,SAAS;AAUb;;AARI;;AAVJ;QAWQ,aAAa;QACb;AAMR;IALI;;AAEA;QACI,gBAAgB;IACpB;;AAGJ;IACI,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;IACtB,4BAA4B;IAC5B,gCAAgC;IAChC,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;AAsBpB;;AApBI;QACI,WAAW;QACX,cAAc;QACd,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,2HAA2H;IAC/H;;AAEA;;AArBJ;QAsBQ,kBAAkB;QAClB,gCAAgC;QAChC;AAMR;;QAJQ;YACI,aAAa;QACjB;IACJ;;AAGJ;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,4BAA4B;AAUhC;;AARI;;QAEI,gBAAgB;IACpB;;AAEA;QACI,mBAAmB;IACvB;;AAGJ;IACI,aAAa;IACb,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,4BAA4B;IAC5B,mBAAmB;AASvB;;AAPI;;AARJ;QASQ;AAMR;IALI;;AAEA;QACI,gBAAgB;IACpB;;AAGJ;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AASb;;AAPI;;AALJ;QAMQ,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;QAClB,cAAc;QACd;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AAOb;;AALI;;AALJ;QAMQ,aAAa;QACb,qCAAqC;QACrC;AAER;IADI;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAgB;SAAhB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,sCAAsC;IACtC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AA2EtB;;AAzEI;QACI;YACI,+BAA+B;QACnC;IACJ;;AAEA;;AAbJ;QAcQ;AAkER;;QAhEQ;YACI,iBAAiB;QACrB;;QAEA;YACI,YAAY;YACZ,yBAAyB;YACzB,YAAY;YACZ,UAAU;YACV,sBAAsB;YACtB,6BAA6B;QACjC;;QAEA;;;;YAII,YAAY;YACZ,gBAAgB;YAChB,YAAY;YACZ,sBAAsB;YACtB,gCAAgC;QACpC;IACJ;;AAEA;;AAzCJ;QA0CQ;AAsCR;;QApCQ;YACI,YAAY;YACZ,aAAa;YACb,WAAW;YACX,QAAQ;YACR,2BAA2B;QAC/B;;QAEA;YACI,YAAY;YACZ,yBAAyB;YACzB,YAAY;YACZ,UAAU;QACd;;QAEA;YACI,YAAY;YACZ,YAAY;YACZ,sBAAsB;YACtB,2BAA2B;QAC/B;;QAEA;YACI,YAAY;YACZ,YAAY;YACZ,8BAA8B;QAClC;;QAEA;YACI,YAAY;YACZ,yBAAyB;YACzB,UAAU;YACV,QAAQ;YACR,sBAAsB;QAC1B;IACJ;;AAGJ;IACI,WAAW;AAKf;;AAHI;;AAHJ;QAIQ;AAER;IADI;;AAGJ;IACI,WAAW;AAKf;;AAHI;;AAHJ;QAIQ;AAER;IADI;;AAGJ;IACI,WAAW;IACX,aAAa;AASjB;;AAPI;;AAJJ;QAKQ;AAMR;;QAJQ;YACI,gBAAgB;QACpB;IACJ;;AAGJ;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;AASd;;AAPI;;AANJ;QAOQ;AAMR;IALI;;AAEA;;AAVJ;QAWQ;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,wCAAwC;IACxC,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;AAKhC;;AAHI;;AATJ;QAUQ;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AAOb;;AALI;;AALJ;QAMQ,aAAa;QACb,iCAAiC;QACjC;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AAMrB;;AAJI;;AANJ;QAOQ,YAAY;QACZ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AAOb;;AALI;;AALJ;QAMQ,aAAa;QACb,qCAAqC;QACrC;AAER;IADI;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,2BAA2B;AAK/B;;AAHI;;AATJ;QAUQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".root {\n    width: 100%;\n    min-height: calc(100vh - 216px);\n}\n\n.main {\n    background-color: var(--main-color);\n    padding: 0 16px 32px 16px;\n\n    @media (--large) {\n        padding: 0 60px 60px 60px;\n    }\n\n    @media (--tablet) {\n        padding: 0 16px 32px 16px;\n    }\n}\n\n.secondaryContent {\n    background-color: var(--obscure-color);\n    padding: 32px 16px;\n\n    @media (--large) {\n        padding: 60px;\n    }\n\n    @media (--tablet) {\n        padding: 60px 16px;\n    }\n}\n\n.wrapper {\n    max-width: var(--content-max-width);\n    width: 100%;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n}\n\n.section {\n    border: 4px solid var(--obscure-color);\n    background-color: var(--main-light-color);\n    border-radius: 12px;\n}\n\n.sectionStatictics {\n    border: 4px solid var(--tertiary-color);\n    background-color: var(--main-light-color);\n    border-radius: 12px;\n    padding: 16px;\n    color: var(--darkest-color);\n    display: flex;\n    flex-direction: column;\n    gap: 36px;\n\n    @media (--large) {\n        padding: 32px;\n        margin-bottom: 28px;\n    }\n\n    .description {\n        margin-bottom: 0;\n    }\n}\n\n.sectionWithBg {\n    padding: 32px 16px;\n    background-position: 65%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-image: var(--main-bg);\n    color: var(--darkest-color);\n    position: relative;\n    overflow: hidden;\n\n    &::after {\n        content: '';\n        display: block;\n        width: 250%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        background: linear-gradient(269.99deg, rgba(216, 217, 239, 0) 50.53%, rgba(249, 249, 253, 0.853946) 79.62%, #FFFFFF 99.99%);\n    }\n\n    @media (--large) {\n        padding: 92px 32px;\n        background-image: var(--main-bg);\n        background-position: center;\n\n        &::after {\n            display: none;\n        }\n    }\n}\n\n.sectionWithBgWrapper {\n    max-width: 468px;\n    position: relative;\n    z-index: 1;\n}\n\n.sectionAbout {\n    color: var(--tertiary-color);\n\n    .secondaryTitle,\n    .description {\n        max-width: 468px;\n    }\n\n    .description {\n        margin-bottom: 24px;\n    }\n}\n\n.sectionReady {\n    padding: 16px;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    color: var(--tertiary-color);\n    border-radius: 12px;\n\n    @media (--large) {\n        padding: 28px 32px 32px;\n    }\n\n    .description {\n        margin-bottom: 0;\n    }\n}\n\n.title {\n    font-size: 32px;\n    line-height: 42px;\n    font-weight: 400;\n    margin-bottom: 16px;\n}\n\n.secondaryTitle {\n    font-weight: 700;\n    font-size: 26px;\n    line-height: 34px;\n    margin-bottom: 16px;\n}\n\n.tertiaryTitle {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 32px;\n    margin-bottom: 16px;\n}\n\n.description {\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 20px;\n    margin-bottom: 32px;\n}\n\n.tag {\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n    color: var(--main-color);\n}\n\n.button {\n    width: 100%;\n    max-width: 260px;\n    margin-bottom: 16px;\n    font-size: 12px;\n    font-weight: 700;\n}\n\n.buttonStart {\n    font-size: 12px;\n    font-weight: 700;\n} \n\n.buttonLearn {\n    --icon-size: 16px;\n    border-color: var(--gray-color);\n    color: var(--main-light-color);\n    font-size: 12px;\n    font-weight: 700;\n}\n\n.buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    @media (--large) {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        align-items: start;\n        grid-gap: 24px;\n        padding-top: 24px;\n    }\n}\n\n.smallNotice {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: var(--darkest-color);\n    max-width: 260px;\n}\n\n.advantageList {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    @media (--large) {\n        display: grid;\n        grid-template-columns: repeat(4, 1fr);\n        grid-gap: 24px;\n    }\n}\n\n.advantageItem {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.advantageItemImage {\n    width: 32px;\n    height: 32px;\n}\n\n.advantageItemTitle {\n    color: var(--tertiary-color);\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 20px;\n}\n\n.advantageItemDescription {\n    color: var(--tertiary-color);\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;    \n}\n\n.serviceList {\n    display: flex;\n    flex-wrap: wrap;\n    column-gap: 12px;\n    row-gap: 24px;\n}\n\n.serviceCard {\n    border: 4px solid var(--obscure-color);\n    background-color: var(--main-light-color);\n    border-radius: 12px;\n    padding: 12px;\n    position: relative;\n\n    @media (--tiny-only) {\n        &:nth-child(3) .serviceCardImageBg {\n            background-position: -35px 22px;\n        }\n    }\n\n    @media (--mobile) {\n        overflow: hidden;\n\n        &:nth-child(2) {\n            overflow: visible;\n        }\n    \n        &:nth-child(2) .serviceCardImageBg {\n            width: 122px;\n            height: calc(100% + 15px);\n            right: -15px;\n            top: -15px;\n            background-size: cover;\n            background-position: top left;\n        }\n    \n        &:nth-child(1) .serviceCardImageBg,\n        &:nth-child(3) .serviceCardImageBg,    \n        &:nth-child(4) .serviceCardImageBg,\n        &:nth-child(5) .serviceCardImageBg {\n            width: 33.3%;\n            max-width: 220px;\n            height: 100%;\n            background-size: cover;\n            background-position: left center;\n        }\n    }\n\n    @media (--large) {\n        padding: 28px;\n\n        &:nth-child(1) .serviceCardImageBg {\n            width: 220px;\n            height: 220px;\n            right: 20px;\n            top: 50%;\n            transform: translateY(-50%);\n        }\n\n        &:nth-child(2) .serviceCardImageBg {\n            width: 134px;\n            height: calc(100% + 15px);\n            right: -15px;\n            top: -11px;\n        }\n\n        &:nth-child(3) .serviceCardImageBg {\n            width: 112px;\n            height: 100%;\n            background-size: cover;\n            background-position: -4px 0;\n        }\n\n        &:nth-child(4) .serviceCardImageBg {\n            width: 272px;\n            height: 100%;\n            background-position: top right;\n        }\n\n        &:nth-child(5) .serviceCardImageBg {\n            width: 382px;\n            height: calc(100% + 32px);\n            top: -28px;\n            right: 0;\n            background-size: cover;\n        }\n    }\n}\n\n.serviceCardSmall {\n    width: 100%;\n\n    @media (--large) {\n        width: 386px;\n    }\n}\n\n.serviceCardMedium {\n    width: 100%;\n\n    @media (--large) {\n        width: 562px;\n    }\n}\n\n.serviceCardBig {\n    width: 100%;\n    padding: 12px;\n\n    @media (--large) {\n        padding: 12px 28px 28px 28px;\n\n        .serviceCardContent {\n            max-width: 517px;\n        }\n    }\n}\n\n.serviceCardContent {\n    max-width: 200px;\n    color: var(--darkest-color);\n    position: relative;\n    z-index: 2;\n\n    @media (--large) {\n        max-width: 240px;\n    }\n\n    @media (--small-tablet) {\n        max-width: 300px;\n    }\n}\n\n.serviceCardTitle {\n    font-weight: 400;\n    font-size: 22px;\n    line-height: 28px;\n    margin-bottom: 16px;\n}\n\n.serviceCardDescription {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;\n}\n\n.serviceCardImageBg {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-image: var(--mobile-image-bg);\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n\n    @media (--large) {\n        background-image: var(--image-bg);\n    }\n}\n\n.serviceCardTag {\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n    color: var(--warning-color);\n}\n\n.secondaryWrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    @media (--large) {\n        display: grid;\n        grid-template-columns: 436px auto;\n        grid-gap: 24px;\n    }\n}\n\n.mark {\n    font-weight: 600;\n    font-style: italic;\n    font-size: 14px;\n    line-height: 18px;\n\n    @media (--large) {\n        width: 320px;\n        margin-left: auto;\n    }\n}\n\n.statisticsList {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    @media (--large) {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        grid-gap: 24px;\n    }\n}\n\n.statisticCard {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 16px;\n    border-radius: 12px;\n    background-color: var(--tertiary-color);\n    color: var(--darkest-color);\n\n    @media (--large) {\n        padding: 32px;\n    }\n}\n\n.statisticCardWrapper {\n    display: grid;\n    grid-template-columns: 32px auto;\n    align-items: center;\n    grid-gap: 16px;\n}\n\n.statisticCardImage {\n    width: 32px;\n    height: 32px;\n}\n\n.statisticCardTitle {\n    font-weight: 400;\n    font-size: 22px;\n    line-height: 28px;\n}\n\n.statisticCardDescription {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `StartPage__root--MlIS`,
	"main": `StartPage__main--olch`,
	"secondaryContent": `StartPage__secondaryContent--YOuY`,
	"wrapper": `StartPage__wrapper--ivVu`,
	"section": `StartPage__section--b45V`,
	"sectionStatictics": `StartPage__sectionStatictics--a6xm`,
	"description": `StartPage__description--oyRA`,
	"sectionWithBg": `StartPage__sectionWithBg--KcvV`,
	"sectionWithBgWrapper": `StartPage__sectionWithBgWrapper--wqem`,
	"sectionAbout": `StartPage__sectionAbout--iAtI`,
	"secondaryTitle": `StartPage__secondaryTitle--lH_5`,
	"sectionReady": `StartPage__sectionReady--BcDI`,
	"title": `StartPage__title--LlZu`,
	"tertiaryTitle": `StartPage__tertiaryTitle--d5Q1`,
	"tag": `StartPage__tag--wFXB`,
	"button": `StartPage__button--pTv_`,
	"buttonStart": `StartPage__buttonStart--YSrC`,
	"buttonLearn": `StartPage__buttonLearn--iQk6`,
	"buttons": `StartPage__buttons--Vcl8`,
	"smallNotice": `StartPage__smallNotice--oq0H`,
	"advantageList": `StartPage__advantageList--MPYi`,
	"advantageItem": `StartPage__advantageItem--uq8L`,
	"advantageItemImage": `StartPage__advantageItemImage--oZCX`,
	"advantageItemTitle": `StartPage__advantageItemTitle--yhA4`,
	"advantageItemDescription": `StartPage__advantageItemDescription--pnhQ`,
	"serviceList": `StartPage__serviceList--Sh8c`,
	"serviceCard": `StartPage__serviceCard--A4JE`,
	"serviceCardImageBg": `StartPage__serviceCardImageBg--FXkM`,
	"serviceCardSmall": `StartPage__serviceCardSmall--j_cw`,
	"serviceCardMedium": `StartPage__serviceCardMedium--dMGV`,
	"serviceCardBig": `StartPage__serviceCardBig--lESw`,
	"serviceCardContent": `StartPage__serviceCardContent--H8TB`,
	"serviceCardTitle": `StartPage__serviceCardTitle--ohbZ`,
	"serviceCardDescription": `StartPage__serviceCardDescription--DfZ9`,
	"serviceCardTag": `StartPage__serviceCardTag--Is08`,
	"secondaryWrapper": `StartPage__secondaryWrapper--Z0cE`,
	"mark": `StartPage__mark--QIhK`,
	"statisticsList": `StartPage__statisticsList--cxRT`,
	"statisticCard": `StartPage__statisticCard--cE93`,
	"statisticCardWrapper": `StartPage__statisticCardWrapper--FthL`,
	"statisticCardImage": `StartPage__statisticCardImage--Ncn7`,
	"statisticCardTitle": `StartPage__statisticCardTitle--GHNi`,
	"statisticCardDescription": `StartPage__statisticCardDescription--gJDZ`
};
export default ___CSS_LOADER_EXPORT___;
